export const ALL = 'ALL';
export const DETAILS = 'DETAILS';
export const ADD_FAVORITE = 'ADD_FAVORITE';
export const DELETE_FAVORITE = 'DELETE_FAVORITE';

